import ArticleTeaser from "./ArticleTeaser";

export default ArticleTeaser;
